import {
  Info as Icon
} from 'components/icons';

export const meta = {
  id: 'Products',
  title: 'Products',
  category: '',
  unique: true,
  icon: Icon,
  version: '1.0.0',
  description: `The crud for managing the current org products'`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
